import React from 'react';
import { I18n } from '@fiverr-private/i18n-react';
import { PinIcon } from '@fiverr-private/icons';
import { Stack } from '@fiverr-private/layout_components';
import { theme } from '@fiverr-private/theme';
import { Text } from '@fiverr-private/typography';
import { useAgencySellerData } from '../../hooks/useAgencySellerData';
import { AgencySeller } from '../../types';

export const Location = () => {
    const { address } = useAgencySellerData(selectSellerSlice);

    if (!address) {
        return null;
    }

    const { countryCode } = address;

    return (
        <Stack gap="1" alignItems="center">
            <PinIcon size={16} color={theme.colors.grey_1200} />
            <Text size="b_lg" fontWeight="semibold" color="bodyPrimary">
                <I18n k={`countries.${countryCode}`} />
            </Text>
        </Stack>
    );
};

function selectSellerSlice(seller: AgencySeller) {
    return {
        address: seller.user.address,
    };
}
